export enum UomEnum {
    LB = 'lb',
    //*  IN_PROGRESS not in use.
    // IN_PROGRESS = 'IN_PROGRESS',
    KG = 'kg',
    OZ = 'oz',
    Gms = 'gm',
}